export const NHL_HEADER_COPY = {
  eyebrow: "Sports Hub • NHL",
  title: "NHL Terminal",
  description: "Track live NHL games, monitor league action, and tap into AI predictions for every matchup.",
};
